export const USER_PICKER_EMPTY = 'USER_PICKER_EMPTY' as const;
